<style lang="less">
.page {
  text-align: center;
  padding: 0 2em 1em 2em;
  position: relative;

  .back-btn {
    position: absolute;
    width: 1.99em;
    top: 0;
    left: 0;
    bottom: 0;
    background: url(/static/back.svg) no-repeat left .1em center / 70% auto;
    box-shadow: 1px 0 0 #ccc;
  }

  .title {
    margin: 1em 0;
    font-size: 1.15em;
    position: relative;
    &::after {
      content: "~";
      position: absolute;
      color: #c3c3c3;
      left: 0;
      right: 0;
      bottom: -.8em;
      text-align: center;
    }
  }

  .icon {
    width: 80%;
    max-width: 9.6em;
    margin: 0 auto;
    background: no-repeat center / contain;
    &::after {
      content: "";
      display: block;
      padding-bottom: 100%;
    }
  }

  .value {
    margin-top: 1em;
    a {
      display: inline-block;
      border-bottom: 1px solid rgba(44, 62, 80, 0.72);
      position: relative;

      &::after {
        content: "";
        position: absolute;
        top: 0.25em;
        right: -1.5em;
        width: 1em;
        height: 1em;
        background: url(/static/copy.svg) no-repeat center / contain;
      }
    }
  }

}
</style>

<template>
<div class="page">
  <a href="#/" class="back-btn"></a>
  <div class="title">
    <span>{{ name }}</span>
  </div>
  <div class="icon" :style="{
    'background-image': `url(${staticDir + (album || icon)})`
  }"></div>
  <div class="value">
    <a @click="copyValue">{{ value }}</a>
  </div>
</div>
</template>

<script>
import {staticDir, pages} from '../data'

export default {
  name: 'Page',
  data () {
    return {
      staticDir,

      name: '',
      icon: '',
      album: '',
      value: ''
    }
  },
  methods: {
    copyValue() {
      copyText(this.value)
    }
  },
  beforeRouteEnter (to, from, next) {
    let name = to.params.name
    // console.log('name', name)
    let page = pages.filter(function (page) {
      return page.name.toLowerCase() === name.toLowerCase()
    })
    if (page) {
      page = page[0]
    }
    if (page) {
      next(vm => {
        Object.assign(vm, page)
      })
    }
    else {
      next(false)
    }
  }
}

function copyText(value) {
  let fakeElem = document.createElement('TEXTAREA')
  fakeElem.style.position = 'absolute'
  fakeElem.style.left = '-9999px'
  fakeElem.style.top = (window.pageYOffset || document.documentElement.scrollTop) + 'px'
  fakeElem.readonly = true
  fakeElem.value = value
  document.body.appendChild(fakeElem)
  fakeElem.focus()
  fakeElem.setSelectionRange(0, value.length)
  try {
    document.execCommand('copy')
  } catch (err) {
    console.log('不支持复制: ' + err.message)
  }
  fakeElem.blur()
  document.body.removeChild(fakeElem)
}
</script>



// WEBPACK FOOTER //
// Page.vue?df764dfe